module.exports = __webpack_public_path__ + "img/echoAR.9bb2df57.png";